module.exports = __webpack_public_path__ + "static/img/ac.d01fa350.svg";